import React from 'react';
import { sendToTerminal } from '../../../lib/terminalLogger';
import { AlertTriangle, X } from 'lucide-react';
import { ConfirmModalProps } from './ConfirmModal.types';
import { Button } from '../Button';

export function ConfirmModal({
  title = 'Confirmação necessária',
  message,
  confirmLabel = 'OK',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel
}: ConfirmModalProps) {
  const handleCancel = () => {
    try { sendToTerminal('❎ [CONFIRM_MODAL:CANCEL]'); } catch {}
    onCancel();
  };

  const handleCancelButton = () => {
    try { sendToTerminal('❎ [CONFIRM_MODAL:CANCEL_BUTTON]'); } catch {}
    onCancel();
  };

  const handleConfirm = () => {
    try { sendToTerminal('✅ [CONFIRM_MODAL:CONFIRM_BUTTON]'); } catch {}
    onConfirm();
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-3">
      <div className="bg-navy-800 rounded-xl w-full max-w-[290px] shadow-2xl border border-navy-600/50 overflow-hidden">
        <div className="flex justify-between items-center p-4 border-b border-navy-700/50 bg-gradient-to-r from-navy-800 to-navy-700/30">
          <div className="flex items-center gap-2">
            <span className="p-2 bg-yellow-400/15 rounded-lg ring-1 ring-yellow-400/20">
              <AlertTriangle className="w-5 h-5 text-yellow-400" />
            </span>
            <h3 className="text-sm font-bold text-white leading-tight">{title}</h3>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            title="Fechar"
            className="p-1.5"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
        <div className="p-4 space-y-4">
          <div className="bg-gradient-to-r from-navy-700/40 to-navy-600/20 rounded-lg p-3 border border-navy-600/30 text-xs text-gray-200 whitespace-pre-wrap">
            {message}
          </div>
          <div className="flex gap-2 justify-end">
            <Button
              variant="ghost"
              onClick={handleCancelButton}
            >
              {cancelLabel}
            </Button>
            <Button
              variant="warning"
              onClick={handleConfirm}
            >
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

